import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "./lohstyle.css";
import * as Login from "../../network/api/loginapi";
import { Cookies } from "react-cookie";
import { useNavigate } from "react-router-dom";

const LoginPage = (props) => {
  const cookie = new Cookies();
  const navigate = useNavigate();
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const user = await Login.loginapi(userName, password);

      if (cookie.get("crm") !== undefined) {
        props.setIsLogin(true)
        navigate("/", { replace: true });
      } else {
        if (
          user.message === "Login Successfully!") {
          toast.success(user.message, {
            position: toast.POSITION.TOP_LEFT,
          });
        } else{
          toast.warn(user.message, {
            position: toast.POSITION.TOP_LEFT,
          });
        }
      }
    } catch (error) {
      toast.error("Something went wrong", {
        position: toast.POSITION.TOP_LEFT,
      });
    }
    };

  return (
    <div className="login-page">
      {/* LEFT SIDE */}

      <div className="login-left">
        <div className="overlay-circle"></div>

        <div className="login-left-content">
          <h1>Welcome Back 👋</h1>

          <p>
            Login to continue managing your account and access
            all features easily and securely.
          </p>
        </div>
      </div>

      {/* RIGHT SIDE */}

      <div className="login-right">
        <div className="login-card">
          <div className="form-box">
          <form
                  className="active"
                  onSubmit={handleSubmit}
                >
                  <div className="form-group">
                    <label>User Name</label>
          
                    <input
                      className="logininput"
                      type="text"
                      value={userName}
                      placeholder="Enter your username"
                      onChange={(e) =>
                        setUserName(e.target.value)
                      }
                      required
                    />
                  </div>
          
                  <div className="form-group">
                    <label>Password</label>
          
                    <input
                      className="logininput"
                      type="password"
                      value={password}
                      placeholder="Enter your password"
                      onChange={(e) =>
                        setPassword(e.target.value)
                      }
                      required
                    />
                  </div>
          
                  <button className="loginbtn" type="submit">
                    Login
                  </button>
          
                  <button
                    className="forgetpass"
                    type="button"
                    data-bs-target="#Forgot"
                    data-bs-toggle="modal"
                  >
                    Forgot your password?
                  </button>
                </form>
                </div>
        </div>
      </div>
       <ToastContainer />
    </div>
  );
}

export default LoginPage;